import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DiagnosisService } from '../services/diagnosis.service';
import { Diagnosis } from '../models/diagnosis.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-diagnosis-form',
  templateUrl: './diagnosis-form.component.html'
})
export class DiagnosisFormComponent {
  constructor(public service: DiagnosisService, private notificationService: NotificationService) { }

  @Input() model: Diagnosis;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.diagnosisID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

